// word-html.js - Markdown des Befunds als HTML fuer die Zwischenablage (Alt+C)
//
// Jede Editorzeile wird genau ein Absatz, jede Leerzeile genau ein leerer
// Absatz. Frueher liefen die Zeilen als <br> durch den <body>: Word machte
// daraus einen einzigen Absatz mit Normal-Abstand und setzte vor einer
// nummerierten Liste zusaetzlich einen leeren Absatz — zwischen „Beurteilung"
// und dem Text standen dadurch mehrere Zeilen zu viel. Die Abstaende stehen
// inline an jedem Element, weil nicht jedes Ziel den <style>-Block liest.

const ABSATZ = 'margin:0cm;font-family:Arial,sans-serif;font-size:11pt;line-height:normal';
const LISTE = 'margin:0cm;padding-left:0.63cm;text-indent:-0.63cm';

function escape(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function inline(text) {
  let html = escape(text);
  // Reihenfolge wichtig: *** vor ** vor *
  html = html.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/___(.+?)___/g, '<strong><em>$1</em></strong>');
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
  html = html.replace(/_(.+?)_/g, '<em>$1</em>');
  html = html.replace(/~~(.+?)~~/g, '<s>$1</s>');
  html = html.replace(/==(.+?)==/g, '$1');
  html = html.replace(/`(.+?)`/g, "<code style=\"font-family:'Courier New',monospace;font-size:10pt\">$1</code>");
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');
  return html;
}

// Nur der Inhalt von <body>: ein Block je Zeile, ohne Zeilenumbrueche
// dazwischen, damit kein Ziel aus dem Quelltext-Whitespace Leerraum macht.
export function markdownToWordBody(markdown) {
  const zeilen = markdown.replace(/\r\n?/g, '\n').split('\n');
  while (zeilen.length && !zeilen[zeilen.length - 1].trim()) zeilen.pop();

  const bloecke = [];
  let liste = null;
  const listeSchliessen = () => {
    if (liste) {
      bloecke.push(`<ol style="${LISTE}">${liste.join('')}</ol>`);
      liste = null;
    }
  };

  for (const zeile of zeilen) {
    const nummer = zeile.match(/^\s*\d+\.\s+(.+)$/);
    if (nummer) {
      liste ??= [];
      liste.push(`<li style="${ABSATZ};${LISTE}">${inline(nummer[1])}</li>`);
      continue;
    }
    listeSchliessen();

    if (!zeile.trim()) {
      bloecke.push(`<p style="${ABSATZ}">&nbsp;</p>`);
      continue;
    }
    const ueberschrift = zeile.match(/^#{1,6}\s+(.*)$/);
    if (ueberschrift) {
      bloecke.push(`<p style="${ABSATZ}"><strong>${inline(ueberschrift[1])}</strong></p>`);
      continue;
    }
    const punkt = zeile.match(/^(\s*)[-*+]\s+(.+)$/);
    const text = punkt ? `${punkt[1]}- ${punkt[2]}` : zeile;
    bloecke.push(`<p style="${ABSATZ}">${inline(text)}</p>`);
  }
  listeSchliessen();
  return bloecke.join('');
}

export function wordHtml(markdown) {
  return '<html><head><meta charset="utf-8"></head>'
    + `<body style="${ABSATZ}">${markdownToWordBody(markdown)}</body></html>`;
}
